module.exports = __webpack_public_path__ + "img/lions.b3e68932.webp";